import React from "react"
import { Table } from "antd"

export default function AuditLogEventChangeset({ changes, importedBy }) {
    console.log(changes)

    // Show the OCR importer's email rather than a bare user id (MUC-210).
    const displayValue = (key, value) => {
        if (key === "imported_by_id" && importedBy && value?.toString() === importedBy.id?.toString()) {
            return importedBy.email
        }
        return value?.toString() ?? "--"
    }

    return (
        <Table
        pagination={false}
        rowKey={(r) => r.field}
        dataSource={Object.keys(changes).map((key) => {
                return {
                    field: key,
                    from: displayValue(key, changes[key]?.[0]),
                    to: displayValue(key, changes[key]?.[1]),
                }
            })}>
            <Table.Column title="Field" key="field" dataIndex="field" />
            <Table.Column title="From" key="from" dataIndex="from" />
            <Table.Column title="To" key="to" dataIndex="to" />
        </Table>
    )
}
